import { render } from "./Layout2.vue?vue&type=template&id=4cbbe437&scoped=true&ts=true"
import script from "./Layout2.vue?vue&type=script&lang=ts"
export * from "./Layout2.vue?vue&type=script&lang=ts"

import "./Layout2.vue?vue&type=style&index=0&id=4cbbe437&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbbe437"]])

export default __exports__